// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

var encoding = require("./lib/encoding.js");

module.exports = {
  TextEncoder: encoding.TextEncoder,
  TextDecoder: encoding.TextDecoder,
};



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/text-encoding/index.js
// module id = 499
// module chunks = 0